import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { HomeResolverData } from '@models/resolver.model';
import { SearchLocationRequestModel } from '@models/location.model';
import {
    HomePromotion,
    ImageTypeEnum,
    SearchPromotionFlightRequest,
    SearchUserViewPromotionPageableReq
} from '@models/promotion.model';
import { CheapFlightService } from '@services/cheap-flight.service';
import { LocationService } from '@services/location.service';
import { PopularFlightService } from '@services/popular-flight.service';
import { PromotionService } from '@services/promotion.service';
import { forkJoin, map } from 'rxjs';

export const homeResolver: ResolveFn<HomeResolverData> = () => {
    const popularFlightService = inject(PopularFlightService);
    const locationService = inject(LocationService);
    const promotionService = inject(PromotionService);
    const cheapFlightService = inject(CheapFlightService);

    /**
     * Get favorite locations
     *
     * @return {*} 
     */
    const getFavoriteLocations = () => {
        const reqParams: SearchLocationRequestModel = {
            SearchText: '',
            OriginCode: '',
            IsActived: -1,
            p: 1,
            ps: 100,
        };
        return locationService.getListFavoriteLocation(reqParams);
    };

    /**
     * Get user view promotion
     *
     * @return {*} 
     */
    const getUserViewPromotion = () => {
        const reqParams: SearchUserViewPromotionPageableReq = {
            promotionCode: '',
            campaignId: '',
            systemCode: '',
            p: 1,
            ps: 10,
        };

        return promotionService.getUserViewPromotion(reqParams);
    };

    /**
     * Get promotions
     *
     * @return {*} 
     */
    const getPromotions = () => {
        const req: SearchPromotionFlightRequest = {
            SearchText: '',
            CampaignCode: '',
            SystemCode: '',
            PromotionType: '',
            International: -1,
            LimitQuanlityPassenger: 0,
            Segments: null,
            Page: 1,
            PageSize: 4,
        };

        return promotionService.searchPromotionBySegments(req).pipe(
            map((res) => {
                const result: HomePromotion[] = [];

                res.forEach((promo) => {
                    const findImage = promo.Images.find((i) => i.Type === ImageTypeEnum.Banner);
                    if (findImage) {
                        promo.BannerImageUrl = findImage.FileUrl;
                        result.push({
                            ...findImage,
                            PromotionId: promo.Id,
                        });
                    }
                });

                return result.slice(0, 4);
            })
        );
    };

    return forkJoin({
        popularFlights: popularFlightService.getPopularFlight(),
        favoriteLocations: getFavoriteLocations(),
        cheapFlights: cheapFlightService.getCheapFlight(),
        dealHot: getUserViewPromotion(),
        promotions: getPromotions(),
    });
};
